import { render } from "./FormatListBulleted.vue?vue&type=template&id=bc1bc21c"
import script from "./FormatListBulleted.vue?vue&type=script&lang=js"
export * from "./FormatListBulleted.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatListBulleted.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc1bc21c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc1bc21c', __exports__)) {
    api.reload('bc1bc21c', __exports__)
  }
  
  module.hot.accept("./FormatListBulleted.vue?vue&type=template&id=bc1bc21c", () => {
    api.rerender('bc1bc21c', render)
  })

}


export default __exports__